'use client'

import Link from 'next/link'
import { useTheme } from '@/contexts/ThemeContext'

export default function TrainingCostPage() {
  const { theme } = useTheme()

  return (
    <div className={`min-h-screen py-6 xxs:py-3 px-4 xxs:px-2 ${
      theme === 'light'
        ? 'bg-gradient-to-b from-blue-50 to-white'
        : 'bg-gradient-to-b from-gray-900 to-gray-800'
    }`}>
      <div className="max-w-4xl mx-auto">
        <Link href="/guide" className={`hover:underline mb-3 xxs:mb-2 inline-block text-sm xxs:text-xs ${
          theme === 'light' ? 'text-blue-600' : 'text-blue-400'
        }`}>
          ← 입문 가이드 목록
        </Link>

        <article className={`rounded-lg shadow-xl p-6 xxs:p-3 ${
          theme === 'light' ? 'bg-white' : 'bg-gray-800'
        }`}>
          <h1 className={`text-2xl xxs:text-lg font-bold mb-4 xxs:mb-3 ${
            theme === 'light' ? 'text-gray-900' : 'text-white'
          }`}>프리다이빙 강습 비용 안내</h1>

          <div className="max-w-none">
            <p className={`text-sm xxs:text-xs mb-4 xxs:mb-3 ${
              theme === 'light' ? 'text-gray-600' : 'text-gray-400'
            }`}>
              레벨별 프리다이빙 강습 비용과 포함 내역을 안내해드립니다.
            </p>

            <h2 className={`text-base xxs:text-sm font-bold mt-6 xxs:mt-4 mb-3 xxs:mb-2 ${
              theme === 'light' ? 'text-gray-900' : 'text-white'
            }`}>AIDA 자격증 강습 비용</h2>
            <div className="space-y-3 xxs:space-y-2">
              <div className={`p-4 xxs:p-3 border-l-4 border-blue-500 rounded-lg ${
                theme === 'light' ? 'bg-blue-50' : 'bg-blue-900/20'
              }`}>
                <h3 className={`font-bold text-base xxs:text-sm mb-2 xxs:mb-1.5 ${
                  theme === 'light' ? 'text-gray-900' : 'text-white'
                }`}>AIDA 1 (입문)</h3>
                <p className={`text-lg xxs:text-base font-bold mb-2 xxs:mb-1.5 ${
                  theme === 'light' ? 'text-blue-600' : 'text-blue-400'
                }`}>25만원 ~ 35만원</p>
                <p className={`text-xs xxs:text-[10px] ${
                  theme === 'light' ? 'text-gray-600' : 'text-gray-400'
                }`}>
                  • 강습 기간: 1-2일<br />
                  • 이론 교육 + 풀 실습<br />
                  • 교재 및 자격증 발급비 포함<br />
                  • 장비 대여료 포함
                </p>
              </div>

              <div className={`p-4 xxs:p-3 border-l-4 border-green-500 rounded-lg ${
                theme === 'light' ? 'bg-green-50' : 'bg-green-900/20'
              }`}>
                <h3 className={`font-bold text-base xxs:text-sm mb-2 xxs:mb-1.5 ${
                  theme === 'light' ? 'text-gray-900' : 'text-white'
                }`}>AIDA 2 (초급)</h3>
                <p className={`text-lg xxs:text-base font-bold mb-2 xxs:mb-1.5 ${
                  theme === 'light' ? 'text-green-600' : 'text-green-400'
                }`}>45만원 ~ 60만원</p>
                <p className={`text-xs xxs:text-[10px] ${
                  theme === 'light' ? 'text-gray-600' : 'text-gray-400'
                }`}>
                  • 강습 기간: 2-3일<br />
                  • 이론 + 풀 실습 + 바다 실습<br />
                  • 교재 및 자격증 발급비 포함<br />
                  • 장비 대여료 포함
                </p>
              </div>

              <div className={`p-4 xxs:p-3 border-l-4 border-purple-500 rounded-lg ${
                theme === 'light' ? 'bg-purple-50' : 'bg-purple-900/20'
              }`}>
                <h3 className={`font-bold text-base xxs:text-sm mb-2 xxs:mb-1.5 ${
                  theme === 'light' ? 'text-gray-900' : 'text-white'
                }`}>AIDA 3 (중급)</h3>
                <p className={`text-lg xxs:text-base font-bold mb-2 xxs:mb-1.5 ${
                  theme === 'light' ? 'text-purple-600' : 'text-purple-400'
                }`}>60만원 ~ 80만원</p>
                <p className={`text-xs xxs:text-[10px] ${
                  theme === 'light' ? 'text-gray-600' : 'text-gray-400'
                }`}>
                  • 강습 기간: 3-4일<br />
                  • 고급 이론 + 바다 실습<br />
                  • 교재 및 자격증 발급비 포함<br />
                  • AIDA 2 자격증 소지자만 가능
                </p>
              </div>
            </div>

            <h2 className={`text-base xxs:text-sm font-bold mt-6 xxs:mt-4 mb-3 xxs:mb-2 ${
              theme === 'light' ? 'text-gray-900' : 'text-white'
            }`}>추가 비용</h2>
            <div className={`space-y-2 xxs:space-y-1.5 text-xs xxs:text-[10px] ${
              theme === 'light' ? 'text-gray-600' : 'text-gray-400'
            }`}>
              <div className={`flex justify-between items-center p-3 xxs:p-2 rounded-lg ${
                theme === 'light' ? 'bg-gray-50' : 'bg-gray-900'
              }`}>
                <span>풀 입장료 (1회)</span>
                <span className="font-semibold">1만원 ~ 2만원</span>
              </div>
              <div className={`flex justify-between items-center p-3 xxs:p-2 rounded-lg ${
                theme === 'light' ? 'bg-gray-50' : 'bg-gray-900'
              }`}>
                <span>바다 실습 교통비</span>
                <span className="font-semibold">별도</span>
              </div>
              <div className={`flex justify-between items-center p-3 xxs:p-2 rounded-lg ${
                theme === 'light' ? 'bg-gray-50' : 'bg-gray-900'
              }`}>
                <span>개인 장비 구매 (선택)</span>
                <span className="font-semibold">20만원 ~ 100만원</span>
              </div>
            </div>

            <div className={`mt-6 xxs:mt-4 p-4 xxs:p-3 rounded-lg ${
              theme === 'light' ? 'bg-yellow-50' : 'bg-yellow-900/20'
            }`}>
              <h3 className={`font-bold text-base xxs:text-sm mb-2 xxs:mb-1.5 ${
                theme === 'light' ? 'text-gray-900' : 'text-white'
              }`}>💡 비용 절약 팁</h3>
              <ul className={`text-xs xxs:text-[10px] space-y-1.5 xxs:space-y-1 ${
                theme === 'light' ? 'text-gray-600' : 'text-gray-400'
              }`}>
                <li>• 그룹 강습은 개인 강습보다 10-20% 저렴합니다</li>
                <li>• 센터별 프로모션을 확인해보세요</li>
                <li>• 처음에는 장비를 빌려 쓰고, 실력이 늘면 구매하세요</li>
                <li>• 바다 실습은 카풀을 이용하면 교통비를 절약할 수 있습니다</li>
              </ul>
            </div>

            <div className={`mt-6 xxs:mt-4 p-4 xxs:p-3 rounded-lg ${
              theme === 'light' ? 'bg-blue-50' : 'bg-blue-900/20'
            }`}>
              <h3 className={`font-bold text-base xxs:text-sm mb-2 xxs:mb-1.5 ${
                theme === 'light' ? 'text-gray-900' : 'text-white'
              }`}>강습 문의하기</h3>
              <p className={`text-xs xxs:text-[10px] mb-3 xxs:mb-2 ${
                theme === 'light' ? 'text-gray-600' : 'text-gray-400'
              }`}>
                각 센터별 자세한 비용과 일정은 직접 문의해주세요!
              </p>
              <Link
                href="/map"
                className="inline-block px-4 xxs:px-3 py-2 xxs:py-1.5 text-xs xxs:text-[10px] bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
              >
                전국 다이빙풀 찾기
              </Link>
            </div>
          </div>
        </article>
      </div>
    </div>
  )
}
